// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"710e6c52","221":"8be8f93b","367":"8be8f93b","561":"b7916003"}[chunkId] + ".chunk.css";
};